// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"488":"bb022a93","2246":"09e14b1a","2248":"09e14b1a","2770":"09e14b1a","3113":"09e14b1a","3326":"a1aa043a","4411":"09e14b1a","4423":"09e14b1a","6167":"536d486f","6736":"52784d18","7390":"bb022a93","7930":"09e14b1a","9628":"28b6f6d7"}[chunkId] + ".chunk.css";
};